/* Recenzije widget — masonry, load-more, lightbox galerija, modal, ocena. Bez zavisnosti. */
(function () {
  var root = document.querySelector('[data-rv]');
  if (!root) return;
  var grid = root.querySelector('.rv-grid');

  // ---- Masonry (pakuj svaku karticu u trenutno najkraću kolonu) ----
  function colCount(W) {
    if (W >= 1000) return 4;
    if (W >= 680) return 3;
    if (W >= 340) return 2;   // telefoni: 2 kolone kao Vitals
    return 1;
  }
  function masonry() {
    if (!grid) return;
    var W = grid.clientWidth;
    var GAP = W < 560 ? 10 : 16;   // manji razmak na mobilnom
    var cols = colCount(W);
    var colW = (W - (cols - 1) * GAP) / cols;
    var h = [];
    for (var i = 0; i < cols; i++) h.push(0);
    var cards = grid.querySelectorAll('.rv-card:not(.rv-hidden)');
    if (cols === 1) {
      grid.classList.remove('rv-masonry');
      grid.style.height = '';
      cards.forEach(function (c) { c.style.position = ''; c.style.width = ''; c.style.left = ''; c.style.top = ''; });
      return;
    }
    grid.classList.add('rv-masonry');
    grid.style.position = 'relative';
    cards.forEach(function (card) {
      card.style.position = 'absolute';
      card.style.width = colW + 'px';
      var min = 0;
      for (var j = 1; j < cols; j++) if (h[j] < h[min]) min = j;
      card.style.left = (min * (colW + GAP)) + 'px';
      card.style.top = h[min] + 'px';
      h[min] += card.offsetHeight + GAP;
    });
    var max = 0;
    for (var k = 0; k < cols; k++) if (h[k] > max) max = h[k];
    grid.style.height = max + 'px';
  }
  // re-layout kad se slike učitaju + na resize
  if (grid) {
    grid.querySelectorAll('img').forEach(function (img) {
      if (img.complete) return;
      img.addEventListener('load', masonry);
      img.addEventListener('error', masonry);
    });
  }
  var rt;
  window.addEventListener('resize', function () { clearTimeout(rt); rt = setTimeout(masonry, 120); });
  window.addEventListener('load', masonry);
  masonry();

  // ---- Load more ----
  var moreBtn = root.querySelector('[data-rv-more]');
  if (moreBtn) {
    moreBtn.addEventListener('click', function () {
      var hidden = root.querySelectorAll('.rv-card.rv-hidden');
      for (var i = 0; i < hidden.length && i < 8; i++) hidden[i].classList.remove('rv-hidden');
      // priključi load-listenere novim slikama
      root.querySelectorAll('.rv-card:not(.rv-hidden) img').forEach(function (img) {
        if (!img.complete) { img.addEventListener('load', masonry); img.addEventListener('error', masonry); }
      });
      if (root.querySelectorAll('.rv-card.rv-hidden').length === 0) moreBtn.style.display = 'none';
      masonry();
    });
  }

  // ---- Lightbox galerija ----
  var lb = root.querySelector('[data-rv-lightbox]');
  if (lb) {
    var lbImg = lb.querySelector('img');
    var lbCount = lb.querySelector('[data-rv-lb-count]');
    var gallery = [], gi = 0;
    var show = function () {
      lbImg.src = gallery[gi];
      if (lbCount) lbCount.textContent = (gi + 1) + ' / ' + gallery.length;
      lb.toggleAttribute('data-single', gallery.length < 2);
    };
    root.querySelectorAll('.rv-card__photo').forEach(function (ph) {
      ph.style.cursor = 'zoom-in';
      ph.addEventListener('click', function () {
        gallery = (ph.getAttribute('data-rv-photos') || '').split('|').filter(Boolean);
        if (!gallery.length) return;
        gi = 0; show(); lb.classList.add('open');
      });
    });
    var close = function () { lb.classList.remove('open'); lbImg.src = ''; };
    var move = function (d) { gi = (gi + d + gallery.length) % gallery.length; show(); };
    lb.querySelector('[data-rv-lb-close]').addEventListener('click', close);
    lb.querySelector('[data-rv-lb-prev]').addEventListener('click', function (e) { e.stopPropagation(); move(-1); });
    lb.querySelector('[data-rv-lb-next]').addEventListener('click', function (e) { e.stopPropagation(); move(1); });
    lb.addEventListener('click', function (e) { if (e.target === lb) close(); });
    document.addEventListener('keydown', function (e) {
      if (!lb.classList.contains('open')) return;
      if (e.key === 'Escape') close();
      else if (e.key === 'ArrowLeft') move(-1);
      else if (e.key === 'ArrowRight') move(1);
    });
  }

  // ---- Modal ----
  var modal = root.querySelector('[data-rv-modal]');
  var open = root.querySelector('[data-rv-open]');
  if (open && modal) {
    open.addEventListener('click', function () { modal.classList.add('open'); });
    modal.addEventListener('click', function (e) { if (e.target === modal) modal.classList.remove('open'); });
    var cancel = modal.querySelector('[data-rv-close]');
    if (cancel) cancel.addEventListener('click', function () { modal.classList.remove('open'); });
    // posle uspešnog slanja Shopify vrati sa ?contact_posted=true → otvori modal sa "hvala"
    if (/[?&]contact_posted=true/.test(location.search)) modal.classList.add('open');
  }

  // ---- Biranje ocene u modalu ----
  var pick = root.querySelector('[data-rv-pick]');
  var ratingInput = root.querySelector('[data-rv-rating]');
  if (pick && ratingInput) {
    var starsEl = pick.querySelector('.rv-stars');
    pick.addEventListener('click', function (e) {
      var rect = pick.getBoundingClientRect();
      var val = Math.min(5, Math.max(1, Math.ceil((e.clientX - rect.left) / rect.width * 5)));
      ratingInput.value = val;
      if (starsEl) starsEl.style.setProperty('--pct', (val / 5 * 100) + '%');
    });
  }
})();
